/* Newsletter pop-up: shows once the visitor has scrolled far enough, not again for N days after closing,
   never again after signing up. Opens immediately to show the result after a sign-up or an error. */
(function () {
  var DONE_KEY = 'oteha_newsletter_done';
  var CLOSED_KEY = 'oteha_newsletter_closed_at';

  function get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function set(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

  function init() {
    var dialog = document.getElementById('NewsletterPopupDialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';

    var success = dialog.dataset.success === 'true';
    // Shopify reports a sign-up result to every newsletter form on the page; only show errors that came from this one.
    // A successful sign-up from any form (e.g. the footer) opens the pop-up so the visitor still gets the code.
    var errors = dialog.dataset.errors === 'true' && location.hash === '#NewsletterPopup';
    var designMode = dialog.dataset.designMode === 'true';

    function open() {
      if (!dialog.open) dialog.showModal();
      dialog.focus(); // focus the pop-up itself, not the close button (no stray focus ring for mouse/touch users)
      document.documentElement.classList.add('nlp-open');
    }
    function close() { dialog.close(); }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('nlp-open');
      if (!success) set(CLOSED_KEY, String(Date.now()));
    });
    dialog.querySelector('.nlp__close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });

    var copy = dialog.querySelector('.nlp__copy');
    if (copy) {
      copy.addEventListener('click', function () {
        var done = function () { copy.textContent = copy.dataset.copied; };
        if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.copy).then(done, done);
        else done();
      });
    }

    // Any newsletter sign-up on the site (pop-up or footer) counts: never show the pop-up again
    if (success || /[?&]customer_posted=true/.test(location.search)) set(DONE_KEY, '1');

    if (success || errors) { open(); return; }
    if (designMode) return; // in the theme editor it opens when the section is selected

    if (dialog.dataset.showOnPage !== 'true' || dialog.dataset.subscribed === 'true' || get(DONE_KEY)) return;
    var closedAt = parseInt(get(CLOSED_KEY) || '0', 10);
    var days = parseInt(dialog.dataset.days || '3', 10);
    if (closedAt && Date.now() - closedAt < days * 86400000) return;

    var threshold = parseInt(dialog.dataset.scroll || '60', 10) / 100;
    function check() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var progress = scrollable <= 0 ? 1 : window.scrollY / scrollable;
      if (progress >= threshold) {
        window.removeEventListener('scroll', check);
        open();
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: show the pop-up while its section is selected
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (event) {
    var dialog = document.getElementById('NewsletterPopupDialog');
    if (dialog && event.target.contains(dialog) && !dialog.open) dialog.showModal();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var dialog = document.getElementById('NewsletterPopupDialog');
    if (dialog && event.target.contains(dialog) && dialog.open) dialog.close();
  });
})();
